// extracted by mini-css-extract-plugin
export default {"topArrow":"TopProofArrow_topArrow__Q1Uda","dollars":"TopProofArrow_dollars__jyo1E","bottomArrow":"TopProofArrow_bottomArrow__m4b4Z"};